import { compose } from 'redux';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';
import { BULK_ID_MODAL_REDUCER_KEY } from './constants';
import reducer from './reducer';
import { isLoading as isLoadingSelector } from './selectors';
import { emailSubmit as emailSubmitAction, onModalClosed as onModalClosedAction } from './actions';
import BulkIdRegisterModal from './BulkIdRegisterModal';

const mapStateToProps = (state) => ({
  isLoading: isLoadingSelector(state),
});

const mapDispatchToProps = {
  emailSubmit: emailSubmitAction,
  onModalClosed: onModalClosedAction,
};

export default compose(withReducer(BULK_ID_MODAL_REDUCER_KEY, reducer), connect(mapStateToProps, mapDispatchToProps))(BulkIdRegisterModal);
